import { Sale } from '@/types/api/sale';
import { formatMoney } from '@/utils/shared/Utils';
import SaleStatusDisplay from './sale-status-display';
// @ts-ignore
import SalesIcon from '@/images/sales-icon.svg?react';
import { useNavigate } from 'react-router-dom';

interface SaleDisplayProps extends Sale {}

export default function SaleDisplay({ id, groupSaleIndex, profit, status, cutoffAt }: SaleDisplayProps) {
  const navigate = useNavigate();

  return (
    <div
      className="col-span-6 lg:col-span-3 xl:col-span-2 rounded-lg p-4 shadow-sm shadow-black/5 space-y-2 cursor-pointer bg-white"
      onClick={() => {
        navigate(id);
      }}
    >
      <div className="flex items-center gap-2">
        <SalesIcon className="shrink-0 fill-current text-violet-500 dark:text-violet-400" width="16" height="16" />
        <span className="text-lg font-medium text-gray-900">Försäljning #{groupSaleIndex}</span>
      </div>

      <InfoRow label="Vinst" value={formatMoney(profit)} />
      <InfoRow label="Status" value={<SaleStatusDisplay status={status} />} />
      <InfoRow label="Sista beställningsdag" value={new Date(cutoffAt).toLocaleDateString('sv-SE')} />
    </div>
  );
}

function InfoRow({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="flex justify-between items-center">
      <div>{label}</div>
      <div>{value}</div>
    </div>
  );
}
